import { render, staticRenderFns } from "./StoredWorkflowInvocations.vue?vue&type=template&id=bd24ef86&"
import script from "./StoredWorkflowInvocations.vue?vue&type=script&lang=js&"
export * from "./StoredWorkflowInvocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports